import React, { useEffect, useState } from "react";
import { useGetUserDetailsQuery } from "./Myaccountapislice";
import { useNavigate } from "react-router-dom";
import { useEditUserMutation } from "../Admin/adminApiSlice";
import ResetPassword from "./ResetPassword";
import { useUploadCloudImageMutation } from "../reduxworkbook/dataApiSlice";
import { setCredentials } from "../auth/authSlice";
import { useDispatch } from "react-redux";
import useAuth from "../../hooks/useAuth";

export default function MyAccountSetting() {
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(""); // "success" or "error"

  const [
    uploadCloudImage,
    {
      data: uploadImagesData,
      isLoading: isUploadLoding,
      error: uploadError,
      isError: isUploadError,
      isSuccess: isUploadSuccess,
    },
  ] = useUploadCloudImageMutation();

  const [isResetOpen, setIsResetOpen] = useState(false);

  // Fetch user details from API
  const {
    data: user,
    isLoading,
    isError,
    isSuccess,
  } = useGetUserDetailsQuery();

  const [editUser, { data: editedUserData, isEditUserLoading, editUserError }] =
    useEditUserMutation();

  const { username } = useAuth();
  console.log(user);
  const [userUserName, setUserUserName] = useState(null);
  // Form state
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    dob: "",
    phone: "",
    department: "",
    userCompanylogo: null,
    jobTitle: "",
    company: "",
    companySize: "",
    country: "",
  });

  useEffect(() => {
    if (user) {
      // Extract only required fields
      const filteredUserData = {
        name: user.name || "",
        gender: user.gender || "",
        dob: user.dob || "",
        phone: user.phone || "",
        department: user.department || "",
        userCompanylogo: user.userCompanylogo || null,
        jobTitle: user.jobTitle || "",
        company: user.company || "",
        companySize: user.companySize || "",
        country: user.country || "",
      };
      setFormData(filteredUserData);
      setUserUserName(user.username);
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const dispatch = useDispatch();
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await uploadCloudImage(formData).unwrap();
      console.log("Upload Successful:", response);
      setFormData({ ...formData, userCompanylogo: response.file });
      if (username === userUserName) {
        console.log(response.file);
        // dispatch(setCredentials({ logo: response.file }));
      }
    } catch (error) {
      console.error("Upload Failed:", error);
    }
  };

  const handleSave = async () => {
    const newDetails = { ...formData };
    const updatedUser = {
      userId: user._id,
      newDetails,
    };
    try {
      await editUser(updatedUser); // Assuming editUser is an async function

      setMessage("User updated successfully!");
      setMessageType("success");
    } catch (error) {
      setMessage("Error updating user. Please try again.");
      setMessageType("error");
    }
  };

  if (isLoading)
    return <p className="text-blue-500 text-center">Loading user details...</p>;
  if (isError)
    return (
      <p className="text-red-500 text-center">Error fetching user details.</p>
    );
  return (
    <section className="w-full  rounded h-[90%] pt-7">
      <section className="flex flex-wrap items-start justify-start p-[0.8rem]  h-[65%] w-full">
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="username" className="font-medium">
            Name
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="email" className="font-medium">
            Gender
          </label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="dob" className="font-medium">
            Date of Birth
          </label>
          <input
            type="date"
            name="dob"
            value={
              formData.dob
                ? new Date(formData.dob).toISOString().split("T")[0]
                : ""
            }
            onChange={handleChange}
            placeholder="Select your date of birth"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="confirmPassword" className="font-medium">
            Phone
          </label>
          <div className="relative w-full">
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="dob" className="font-medium">
            Department
          </label>
          <input
            type="department"
            name="department"
            value={formData.department}
            onChange={handleChange}
            placeholder="Enter your department (e.g., Sales, Marketing)"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="phone" className="font-medium">
            Job title
          </label>
          <input
            type="text"
            name="jobTitle"
            value={formData.jobTitle}
            onChange={handleChange}
            placeholder="Enter your job title (e.g., Manager, Engineer)"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="zone" className="font-medium">
            Company
          </label>
          <input
            type="company"
            name="company"
            value={formData.company}
            onChange={handleChange}
            placeholder="Enter your company name"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="region" className="font-medium">
            Company Size
          </label>
          <input
            type="companySize"
            name="companySize"
            value={formData.companySize}
            onChange={handleChange}
            placeholder="Enter the number of employees"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="hierarchy" className="font-medium">
            Country
          </label>
          <input
            type="text"
            name="country"
            value={formData.country}
            onChange={handleChange}
            placeholder="Enter your country"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>

        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="fileUpload" className="font-medium">
            User Company Logo
          </label>
          <input
            type="file"
            name="userCompanyLogo"
            onChange={handleFileChange}
            id="fileUpload"
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
      </section>
      <section className="flex flex-col items-end justify-end w-full h-[10%] px-[5rem] py-[0.8rem] gap-4">
        {/* Top buttons: Cancel and Save */}
        <div className="flex gap-4">
          <button
            onClick={() => navigate("/home/dash")}
            className="border rounded py-2 px-3 text-black hover:bg-gray-200 bg-white"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="border rounded py-2 px-6 text-white bg-blue-950 hover:bg-blue-900"
          >
            {editedUserData ? "Saved" : "Save"}
          </button>
        </div>

        {/* Message Display */}
        {message && (
          <div
            className={`mt-2 px-4 py-2 rounded ${
              messageType === "success"
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {message}
          </div>
        )}

        {/* Reset Password Button below */}
        <div className="mt-4">
          <button
            onClick={() => setIsResetOpen(true)}
            className="border rounded py-2 px-4 text-white bg-red-600 hover:bg-red-500"
          >
            Reset Password
          </button>
        </div>
      </section>

      {isResetOpen && <ResetPassword onClose={() => setIsResetOpen(false)} />}
    </section>
  );
}